import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/home"),
    redirect: "/explore",
  },
  {
    path: "/explore",
    name: "Yield",
    component: () => import("@/views/explore"),
  },
  {
    path: "/vaults",
    name: "Vaults",
    component: () => import("@/views/vaults"),
    redirect: "/explore",
    children: [
      {
        path: ":vault",
        name: "VaultDetails",
        component: () => import("@/views/vaults/details"),
      },
    ],
  },
  {
    path: "/stake",
    name: "Stake",
    component: () => import("@/views/stake"),
    redirect: "/explore",
    children: [
      {
        path: "kyber",
        name: "KyberProjectDetails",
        component: () => import("@/views/stake/projects"),
        children: [
          {
            path: "tx",
            name: "KyberTx",
            component: () => import("@/views/stake/projects/kyber/tx"),
          },
        ],
      },
      {
        path: "celer",
        name: "CelerProjectDetails",
        component: () => import("@/views/stake/projects"),
        children: [
          {
            path: "tx",
            name: "CelerTx",
            component: () => import("@/views/stake/projects/celer/tx"),
          },
        ],
      },
      {
        path: "skale",
        name: "SkaleProjectDetails",
        component: () => import("@/views/stake/projects"),
        children: [
          {
            path: "tx",
            name: "SkaleTx",
            component: () => import("@/views/stake/projects/skale/tx"),
          },
        ],
      },
      {
        path: "thegraph",
        name: "ThegraphProjectDetails",
        component: () => import("@/views/stake/projects"),
        children: [
          {
            path: "tx",
            name: "ThegraphTx",
            component: () => import("@/views/stake/projects/thegraph/tx"),
          },
        ],
      },
      {
        path: "solana",
        name: "SolanaProjectDetails",
        component: () => import("@/views/stake/projects"),
        children: [
          {
            path: "tx",
            name: "SolanaTx",
            component: () => import("@/views/stake/projects/solana/tx"),
          },
        ],
      },
      {
        path: "sui",
        name: "SuiProjectDetails",
        component: () => import("@/views/stake/projects"),
        children: [
          {
            path: "tx",
            name: "SuiTx",
            component: () => import("@/views/stake/projects/sui/tx"),
          },
        ],
      },
      {
        path: ":projectName",
        name: "StakeProjectDetails",
        component: () => import("@/views/stake/projects"),
        children: [
          {
            path: "tx",
            name: "TendermintTx",
            component: () => import("@/views/stake/projects/tendermint/tx"),
          },
          {
            path: "proposals",
            name: "TendermintGovernance",
            component: () =>
              import("@/views/stake/projects/tendermint/governance"),
          },
          {
            path: "proposals/:proposalId",
            name: "TendermintProposal",
            component: () =>
              import("@/views/stake/projects/tendermint/governance/proposal"),
          },
        ],
      },
    ],
  },
  {
    path: "/stake/overview",
    redirect: "/explore",
  },
  {
    path: "/vaults/overview",
    redirect: "/explore",
  },
  {
    path: "/stats",
    name: "Stats",
    component: () => import("@/views/stats"),
  },
  {
    path: "/portfolio",
    name: "Portfolio",
    component: () => import("@/views/portfolio"),
  },
  {
    path: "/auth/oauth-redirect/:provider",
    name: "OauthRedirect",
    component: () => import("@/views/auth/oauthRedirect.vue"),
  },
  {
    path: "/auth/reset-password",
    name: "ResetPassword",
    component: () => import("@/views/auth/resetPassword.vue"),
  },
  {
    path: "/settings",
    component: () => import("@/views/settings"),
    redirect: "/settings/account",
    children: [
      {
        path: "account",
        name: "ManageAccount",
        component: () => import("@/views/settings/account"),
      },
      {
        path: "wallets",
        name: "ManageWallets",
        component: () => import("@/views/settings/wallet"),
      },
    ],
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
